var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.bestBuyBannersSet)?_c('div',{staticClass:"best-buy-banner-wrapper"},[_c('best-buy-banners-block',{attrs:{"best-buy-banners":_vm.bestBuyBanners,"best-buy-countries":_vm.bestBuyCountries}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }